<template>
	<div>
		<div class="h4 mb-3">Unsubscribe</div>
		<b-form @submit.prevent="unsubscribe(email)">
			<b-form-group id="input-group-1">
				<b-input id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email" v-model="email"></b-input>
			</b-form-group>

			<b-form-group id="input-group-4">
				<b-button class="w-100" variant="primary" type="submit">Remove Me</b-button>
			</b-form-group>
			<b-form-group id="input-group-5">
				<div class="alert alert-success" v-if="success">{{ success }}</div>
				<div class="alert alert-danger" v-if="error">We couldn't unsubscribe you right now. If you have an account please <router-link to="/sign-in">Sign In</router-link> to turn off your notifications.</div>
			</b-form-group>
		</b-form>
	</div>
</template>

<script>
	export default {
		name: 'Unsubscribe',
		data () {
			return {
				email: this.$route.query.email,
				success: false,
				error: false
			}
		},
		computed: {
			Subscription () {
				const { Subscription } = this.$FeathersVuex.api;
				return Subscription;
			}
		},
		methods: {
			async unsubscribe (email) {
				this.success = this.error = false;
				const subscription = new this.Subscription;
				subscription.id = email;
				try {
					await subscription.remove();
					this.success = "You've been unsubscribed. We're sorry to see you go :D";
				} catch (e) {
					this.error = true;
				}
			}
		}
	}
</script>
